import { authenticatedFetch } from './authenticatedFetch';
import { apiUrl } from './apiBase';

export const PARENT_FEEDBACK_STATUS = {
  pending: 'pending',
  approved: 'approved',
  notPublished: 'notPublished'
};

const normalizeItems = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.feedback)) return data.feedback;
  if (Array.isArray(data?.items)) return data.items;
  if (Array.isArray(data?.results)) return data.results;
  return [];
};

export async function submitParentFeedback({ feedbackText, rating, allowPublicDisplay, headline, subject, grade }) {
  return authenticatedFetch('/api/parent-feedback', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      feedbackText,
      rating: rating ? Number(rating) : undefined,
      allowPublicDisplay: Boolean(allowPublicDisplay),
      headline: headline || undefined,
      subject: subject || undefined,
      grade: grade || undefined
    })
  });
}

export async function getMyParentFeedback() {
  const data = await authenticatedFetch('/api/parent-feedback/mine', { cache: 'no-store' });
  return normalizeItems(data);
}

export async function getAdminParentFeedback({ adminToken, status = 'pending' }) {
  const params = new URLSearchParams();
  if (status) params.set('status', status);
  const query = params.toString();
  const response = await fetch(apiUrl(`/api/mgmt/admin/parent-feedback${query ? `?${query}` : ''}`), {
    cache: 'no-store',
    headers: { 'x-admin-token': adminToken }
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.error || data.message || 'Could not load parent feedback.');
  return normalizeItems(data);
}

export async function moderateParentFeedback({ adminToken, feedbackId, status }) {
  const response = await fetch(apiUrl(`/api/mgmt/admin/parent-feedback/${encodeURIComponent(feedbackId)}`), {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'x-admin-token': adminToken
    },
    body: JSON.stringify({ status })
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.error || data.message || 'Could not update parent feedback.');
  return data;
}

export async function getPublicParentFeedback({ limit = 6 } = {}) {
  const params = new URLSearchParams();
  if (limit) params.set('limit', String(limit));
  const response = await fetch(apiUrl(`/api/public/parent-feedback?${params.toString()}`), {
    cache: 'no-store'
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.error || data.message || 'Could not load public feedback.');
  return normalizeItems(data);
}
